module.exports = __webpack_public_path__ + "img/laina.fi@2x.aab2f82.png";